// UI Overlay library configuration
// Paste external JS URLs to preload into the outer (non-sandbox) wrapper frame
// and/or the inner (sandboxed) UI frame. You may also expose selected globals
// from the outer frame into the inner frame so overlay UI code can access them.
export const overlayLibConfig = {
    // Example:
    // outerScriptUrls: [
    //   'https://cdn.jsdelivr.net/npm/lodash@4.17.21/lodash.min.js',
    // ],
    // outerExposeGlobals: ['_'],
    innerScriptUrls: [
        'https://cdn.jsdelivr.net/npm/emoji-picker-element@^1/index.js',
    ],
    // csp: {
    //   scriptSrc: 'https://cdn.jsdelivr.net https://unpkg.com',
    //   connectSrc: 'https://api.example.com',
    // },
};
